<template>
    <div class="detail-take-order-page">
        <div class="page-wrap">
            <div class="page-title">
                <span class="text1 backIcon" @click="back"><i class="el-icon-arrow-left"></i> 返回</span>
                <router-link class="text1" to="/">首页</router-link>
                <i class="el-icon-arrow-right arrow-right"></i>
                <router-link class="text1" to="/fabric">商品列表</router-link>
                <i class="el-icon-arrow-right arrow-right"></i>
                <span class="text2">商品详情</span>
            </div>
            <div class="mainInfoWrap">
                <div class="leftBox">
                    <div class="imgSection">
                        <div class="imgBox">
                            <viewer :images="[detail.flowerBigPic]" @inited="initedViewer">
                                <img :src="detail.flowerPic" alt="" class="mainImg">
                            </viewer>  
                        </div>
                        <div class="smallIconBox"  @click="showViewer">
                            <i class="icon iconfont icon-fangdajing"></i>
                        </div>
                        <div class="smallCollectBox">
                            <span class="text">
                                <i class="icon iconfont icon-aixin1"></i>
                                收藏
                            </span>

                        </div>
                    </div>
                    <div class="tempImgLists">
                        <div class="oneImgItem">
                            <img :src="detail.flowerSmallPic" alt="" class="tempImg">
                        </div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="titleLine">
                        {{detailTitle}}
                    </div>
                    <div class="priceLine">
                        <span class="label">价格</span>
                        <span class="priceNum">{{detailPrice}}</span>
                    </div>
                    <div class="detailLine">
                        <div class="myLabel">编号</div>
                        <div class="myText">{{detail.flowerName}}</div>
                    </div>
                    <div class="detailLine">
                        <div class="myLabel">设计方</div>
                        <div class="myText">{{detail.stallName}}</div>
                    </div>
                    <div class="detailLine">
                        <div class="myLabel">文件格式</div>
                        <div class="myText">{{detail.fileFormat}}</div>
                    </div>
                    <div class="detailLine">
                        <div class="myLabel">文件分层</div>
                        <div class="myText">
                            {{detail.fileLayered == 'true' ? '是' : ''}}
                            {{detail.fileLayered == 'false' ? '否' : ''}}
                        </div>
                    </div>
                    <div class="detailLine">
                        <div class="myLabel blue">购买方式</div>
                    </div>
                    <div class="radioLine">
                        <el-radio-group v-model="buyType" @change="changeBuyType">
                            <el-radio :label="item.id" :class="{active:buyType==item.id}"
                                v-for="(item, index) in prices" :key="index"
                            >
                                <span class="label">{{item.name}}</span>
                                <span class="text" v-if="item.name == '授权'">使用权，用于生产制造</span>
                                <span class="text" v-if="item.name == '买断'">所有权，花型自动下架</span>
                            </el-radio>
                        </el-radio-group>
                    </div>
                    <div class="buttonBox">
                        <button class="btn blueBtn" style="margin-right: 16px;">立即购买</button>
                        <button class="btn blueBorderBtn">加入购物车</button>
                    </div>
                </div>


            </div>
            
            <imgcontrol></imgcontrol>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import {ufunction} from '@/utils/tools'
    import { mapGetters } from 'vuex'
    import api from '@/api/index.js'
    import request from '@/utils/request'
    import imgcontrol from './imgControlComponents.vue'
    export default {
        data() {
            return {
                
                buyType: '', //购买方式
                dialogImgUrl: '',
                dialogImgVisible: false,
                loading: false,
                marks: {
                    0: '1x',
                    25: '2x',
                    50: '3x',
                    75: {
                        style: {
                            color: '#1989FA'
                        },
                        label: this.$createElement('strong', '4x')
                    },
                    100: {
                        style: {
                            color: '#1989FA'
                        },
                        label: this.$createElement('strong', '5x')
                    }
                },
                detail: {
                    flowerName: '',
                    stallName: '',
                    fileFormat: '',
                    fileLayered: '',
                    flowerBigPic: '',
                    flowerPic: '',
                    flowerSmallPic: ''
                },
                detailTitle: '',
                detailPrice: '',

                prices: [],
                
            }
        },
        created() {
            this.getData();
        },
        mounted() {},
        components:{imgcontrol}, 
        beforeDestroy() {},
        methods: {
            initedViewer(viewer) {
                this.$viewer = viewer
            },
            showViewer() {
                this.$viewer.show()
            },
            back() {
                this.$router.back()
            },
            changeBuyType(e) {
                let detailPrice = this.prices.filter(item => item.id == e)[0].content
                this.detailPrice = '￥' + parseFloat(detailPrice).toFixed(2)
            },
            // 获取详情数据
            getData() {
                request({
                    url: api.getBuJuYunDetail,
                    data: {
                        id: this.$route.query.id, 
                        type: '1'
                    }
                }).then(res => {
                    console.log(res)
                    if (res.errorCode == 200) {
                        this.detail = res.data

                        // 图片地址
                        this.detail.flowerBigPic = api.imgPrev + res.data.flowerBigPic.replace(/^\/share/, '')
                        this.detail.flowerPic = api.imgPrev + res.data.flowerPic.replace(/^\/share/, '')
                        this.detail.flowerSmallPic = api.imgPrev + res.data.flowerSmallPic.replace(/^\/share/, '')
   
                        // 名称
                        try {
                            let typeList = JSON.parse(res.data.typeList)
                            let detailTitle = ''
                            typeList.forEach(a => {
                                a.detailList.forEach(b => {
                                    detailTitle += ' ' + b.name
                                })
                            });
                            this.detailTitle = detailTitle
                        } catch (error) {
                            console.log(error)
                        }
                        // 价格
                        try {
                            let prices = JSON.parse(res.data.prices)
                            console.log(prices)
                            this.prices = prices
                            let detailPrice = ''
                            prices = prices.map(a => {
                                return '￥' + parseFloat(a.content).toFixed(2)
                            })
                            detailPrice = prices.join('~')
                            this.detailPrice = detailPrice
                        } catch (error) {
                            console.log(error)
                        }
                    } else {
                        this.$message.error(res.errorMsg || '网络错误')
                    }
                })
            },

        }
    }
</script>

<style scoped="scoped" lang="scss">
    .blue {
        color: #3F33FF !important;
    }

    .el-carousel__item {
        border: 1px solid red;
    }

    .detail-take-order-page {
        .page-title{padding:24px 0 40px;}
        background-color: #fff;

        .el-radio {
            display: block;
            width: 584px;
            box-sizing: border-box;
            padding: 20px 13px;

            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.65);
            line-height: 20px;

            .label {
                color: rgba(0, 0, 0, 0.85);
                margin-right: 70px;
            }

            .text {
                color: rgba(0, 0, 0, 0.65);
            }
        }

        .el-radio.active {
            background: rgba(63, 51, 255, 0.1);
        }


        .page-wrap {
            background-color: #fff;
            width: 1184px;
            margin: 0 auto;
            padding-bottom: 80px;

            .mainInfoWrap {
                display: flex;

                .leftBox {
                    .imgSection {
                        position: relative;

                        .imgBox {
                            width: 482px;
                            height: 482px;
                            border: 1px solid rgba(0, 0, 0, 0.06);
                            padding: 55px 104px;
                            box-sizing: border-box;

                            .mainImg {
                                width: 274px;
                                height: 373px;
                                cursor: zoom-in;
                            }
                        }

                        .smallIconBox {
                            width: 24px;
                            height: 24px;
                            position: absolute;
                            padding-right: 16px;
                            padding-bottom: 13px;
                            padding-left: 20px;
                            right: 0;
                            bottom: 0;
                            // right: 16px;
                            // bottom: 13px;
                            cursor: pointer;
                        }

                        .smallIconBox:hover {
                            color: #D9363E;
                        }

                        .smallCollectBox:hover {
                            color: #D9363E;
                        }

                        .smallCollectBox {
                            cursor: pointer;
                            position: absolute;
                            right: 0;
                            bottom: -44px;
                            color: rgba(0, 0, 0, 0.65);

                            .icon {
                                font-size: 12px;
                            }

                            .text {
                                font-size: 12px;
                                font-weight: 400;

                                line-height: 17px;
                            }
                        }
                    }

                    .tempImgLists {
                        margin-top: 32px;

                        .oneImgItem {
                            .tempImg {
                                width: 52px;
                                height: 72px;
                                border: 4px solid #FF4D4F;
                            }
                        }
                    }
                }

                .rightBox {
                    padding-left: 68px;

                    .titleLine {
                        font-size: 20px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.85);
                        line-height: 20px;
                    }

                    .priceLine {
                        margin-top: 24px;
                        width: 584px;
                        height: 112px;
                        line-height: 112px;
                        background: #F9F9F9;

                        .label {
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.85);
                            line-height: 20px;
                            margin: 0 40px 0 24px;
                        }

                        .priceNum {
                            font-size: 28px;
                            font-weight: 600;
                            color: #D9363E;
                            line-height: 36px;
                        }
                    }

                    .detailLine {
                        margin-top: 24px;

                        .myLabel {
                            display: inline-block;
                            width: 56px;
                            text-align-last: justify;
                            letter-spacing: 0;
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.65);
                            margin-right: 94px;
                        }

                        .myText {
                            display: inline-block;
                            font-size: 14px;
                            font-weight: 400;
                            color: rgba(0, 0, 0, 0.65);
                            line-height: 20px;
                        }

                    }

                    .radioLine {
                        margin-top: 24px;
                    }

                    .buttonBox {
                        margin-top: 32px;

                        .btn {
                            width: 234px;
                            height: 40px;
                            border-radius: 2px;
                            box-sizing: border-box;
                            font-size: 16px;
                            border: 1px solid #3F33FF;

                        }

                        .blueBorderBtn {
                            color: #3F33FF;
                            background: #fff;

                        }
                    }

                }
            }

            

        }



    }
</style>
